// extracted by mini-css-extract-plugin
module.exports = {"animate_button":"Disputes_animate_button__2Y54f","animate_icon":"Disputes_animate_icon__3tvre","animate_text":"Disputes_animate_text__35giv"};